import React from 'react';
import Button from '../../../../../common/Button/Button';
const TargetCard = ({ 
  targetData,
  onSetTarget 
}) => {
  return (
    <div className="flex flex-col w-full max-w-5xl mx-auto">
      <div className="grid grid-cols-2 md:grid-cols-5 gap-6 mb-6">
        <div className="flex flex-col items-center justify-center bg-light-orange rounded-xl shadow-md p-4">
          <span className="text-sm text-gray-500 mb-1">Water Intake</span>
          <span className="text-lg font-semibold">{targetData.water} ml</span>
        </div>
        <div className="flex flex-col items-center justify-center bg-light-orange rounded-xl shadow-md p-4">
          <span className="text-sm text-gray-500 mb-1">Steps</span>
          <span className="text-lg font-semibold">{targetData.steps} Steps</span>
        </div>
        <div className="flex flex-col items-center justify-center bg-light-orange rounded-xl shadow-md p-4">
          <span className="text-sm text-gray-500 mb-1">Daily Sleep</span>
          <span className="text-lg font-semibold">{targetData.sleep} Hrs</span>
        </div>
        <div className="flex flex-col items-center justify-center bg-light-orange rounded-xl shadow-md p-4">
          <span className="text-sm text-gray-500 mb-1">Target Weight</span>
          <span className="text-lg font-semibold">{targetData.weight} kgs</span>
        </div>
        <div className='flex flex-col items-center justify-center'>
        <Button
          text = "Set Target"
          onClick={onSetTarget}
          className="bg-orange-primary hover:bg-dark-orange text-white font-semibold py-2 px-6  transition"
        />
        </div>
      </div>
     
    </div>
  );
};

export default TargetCard;
